import { AfterViewInit, Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ResponseUSer } from 'src/app/_models';
import { AuthenticationService } from 'src/app/_services';
import { MenuComponent } from '../menu/menu.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit, AfterViewInit {
  ver = 0;
  mySubscription: any;
  currentUser: ResponseUSer;
  constructor(    private router: Router,
    private authenticationService: AuthenticationService) {



    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((events) => {
      this.authenticationService.currentUser.subscribe(x => this.currentUser = x);


    });
     this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.mySubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        console.log("ddddd")
        // Trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = true;
      }
    }) 
  }

  ngOnInit(): void {}
  ngOnDestroy(): void {
    
    if (this.mySubscription) {
      
      this.mySubscription.unsubscribe();
     
    }

  }
  ngAfterViewInit() {
    // var header = localStorage.getItem('header');
    // console.log('header', header);
    // if (header == '1') {
    //   console.log('menu1');

       //this.ver = 0;
    //   this.OnMenu();
    //   document.getElementById('SubMenu').style.display = 'none';
    // } else {
    //   console.log('menu0');
    //   this.ver = 1;
    //   this.OnMenu();
     // document.getElementById('SubMenu').style.display = 'none';
   // }

    var headers = document.getElementById('toolbar');
    var estiloabove = localStorage.getItem('coabove');
    var estilobelow = localStorage.getItem('cobelow');

    if (estiloabove == null) {
      var above = '';
    } else {


	setTimeout(() => {
		document.getElementById("toolbar").style.background=  estiloabove;
		document.querySelector("html").style.cssText="color:"+estilobelow +"!important;";
	}, 2000);
      //headers.style.backgroundColor = estiloabove;
    }
  }
  
  OnMenu() {
    if (this.ver == 0) {
      var element = document.getElementById('SubMenu');
      element.style.display = 'none';
     // this.dd.Menu=false;
      this.ver = 1;
      localStorage.setItem('header', '1');
    } else {
//this.dd.Menu=true;
      var element = document.getElementById('SubMenu');
      element.style.display = 'block';
      this.ver = 0;
      localStorage.setItem('header', '0');
    }
  }
}
